export enum AdditionalVpaStatus {
  ApplyInProgress,
  WaitingForPayment,
  WaitingForSignature,
  SignedAndSubmitted,
  Cancelled
}
